import { ASCENSION_SPIRIT_POWER_TARGET, getRealmLayerInfo, getRequiredSpiritPowerForGameplayLevel, MAX_GAMEPLAY_LEVEL, MIN_GAMEPLAY_LEVEL, REALM_CONFIGS, } from "./level-config.js";
export const ASCENSION_SPIRIT_POWER = ASCENSION_SPIRIT_POWER_TARGET;
export const LEVEL_GROWTH_CONFIGS = Object.fromEntries(Array.from({ length: MAX_GAMEPLAY_LEVEL }, (_, index) => {
    const level = index + 1;
    return [
        level,
        {
            level,
            requiredSpiritPower: getRequiredSpiritPowerForLevel(level),
        },
    ];
}));
export const SPIRIT_STONE_CLASS_CONFIGS = {
    fragment: { id: "fragment", value: 1 },
    condensed: { id: "condensed", value: 10 },
};
export const EARTH_VEIN_CRYSTAL_VALUE = SPIRIT_STONE_CLASS_CONFIGS.condensed.value;
export const HEAVEN_MARROW_CRYSTAL_VALUE = SPIRIT_STONE_CLASS_CONFIGS.condensed.value;
export const SPIRIT_STONE_VALUE_TIERS = [
    SPIRIT_STONE_CLASS_CONFIGS.fragment.value,
    SPIRIT_STONE_CLASS_CONFIGS.condensed.value,
];
export function calculateLevelFromSpiritPower(spiritPower) {
    const normalizedSpiritPower = Math.max(0, Math.floor(spiritPower));
    let level = MIN_GAMEPLAY_LEVEL;
    for (let candidate = MIN_GAMEPLAY_LEVEL; candidate <= MAX_GAMEPLAY_LEVEL; candidate += 1) {
        if (normalizedSpiritPower >=
            LEVEL_GROWTH_CONFIGS[candidate].requiredSpiritPower) {
            level = candidate;
        }
    }
    return level;
}
export function getRequiredSpiritPowerForLevel(level) {
    return getRequiredSpiritPowerForGameplayLevel(level);
}
export function getSpiritStoneClassByValue(value) {
    const normalizedValue = Math.floor(value);
    return (Object.values(SPIRIT_STONE_CLASS_CONFIGS).find((config) => config.value === normalizedValue) ?? null);
}
export function getNextLevelGrowthConfig(level) {
    const nextLevel = Math.floor(level) + 1;
    if (nextLevel > MAX_GAMEPLAY_LEVEL) {
        return null;
    }
    if (nextLevel <= MIN_GAMEPLAY_LEVEL) {
        return LEVEL_GROWTH_CONFIGS[MIN_GAMEPLAY_LEVEL];
    }
    return LEVEL_GROWTH_CONFIGS[nextLevel];
}
export function getGrowthLabel(level) {
    return getRealmLayerInfo(level).label;
}
export function calculateSpiritStoneAbsorption(_currentSpiritPower, stoneValue) {
    const normalizedStoneValue = Math.max(0, Math.floor(stoneValue));
    return {
        absorbedValue: normalizedStoneValue,
        overflowValue: 0,
        overflowStoneValue: null,
        overflowStoneCount: 0,
    };
}
export function getLowerSpiritStoneTierValue(value) {
    const normalizedValue = Math.max(0, Math.floor(value));
    let lowerTier = null;
    for (const tierValue of SPIRIT_STONE_VALUE_TIERS) {
        if (tierValue >= normalizedValue) {
            break;
        }
        lowerTier = tierValue;
    }
    return lowerTier;
}
export function calculateDeathDrop(spiritPower, level = calculateLevelFromSpiritPower(spiritPower)) {
    const normalizedSpiritPower = Math.max(0, Math.floor(spiritPower));
    const totalValue = Math.max(normalizedSpiritPower, 10);
    return {
        totalValue,
        pieces: splitDeathDropValue(totalValue, level),
    };
}
export function splitDeathDropValue(totalValue, level = calculateLevelFromSpiritPower(totalValue)) {
    let remainingValue = Math.max(0, Math.floor(totalValue));
    const pieces = [];
    for (const value of getDeathDropTiersForLevel(level)) {
        const count = Math.floor(remainingValue / value);
        if (count > 0) {
            pieces.push({ value, count });
            remainingValue -= count * value;
        }
    }
    return pieces;
}
export function getDeathDropTiersForLevel(level) {
    void level;
    return [...SPIRIT_STONE_VALUE_TIERS].sort((left, right) => right - left);
}
export function getRealmStartPowers() {
    return REALM_CONFIGS.map((realm) => realm.spiritStart);
}
